/* eslint-disable indent */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  Input,
  NativeSelect,
  Paper,
  Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';
import Loading from '../../../../components/Loading';
import Header from '../../../../layout/Header';
import Subheader from '../../../../layout/Subheader';
import api from '../../../../services/api';
import { findPermission } from '../../../../services/auth';
import { handleErrorRequest } from '../../../../utils/errorsValidation';
import { dddTel, formatDateTimeToRender } from '../../../../utils/functions';
import { TOKEN_USER } from '../../../../services/auth';
import PhoneMask from '../../../Collaborator/components/PhoneMask';
import useStyles from '../style';

export function ContactGroupRegister() {
  const loginId = JSON.parse(sessionStorage.getItem(TOKEN_USER))?.loginId;
  const classes = useStyles();
  const { id, idGrupoContato } = useParams();

  const [isLoading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [isRegister, setIsRegister] = useState(false);

  const [getErros, setErros] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState();
  const [provider, setProvider] = useState();

  const [inputs, setInputs] = useState({
    cargo: '',
    cargoId: 0,
    ddd1: '',
    departamento: '',
    ehWhatsApp: "Indefinido",
    email: '',
    grupoFornecedorContatoId: 0,
    grupoFornecedorId: 0,
    nome: '',
    origemContato: '',
    ramal1: '',
    status: 'Ativo',
    telefone1: '',
  });

  const [formValues, setformValues] = useState({
    cargo: '',
    cargoId: 0,
    ddd1: '',
    departamento: '',
    ehWhatsApp: "Indefinido",
    email: '',
    grupoFornecedorContatoId: 0,
    grupoFornecedorId: 0,
    nome: '',
    origemContato: '',
    ramal1: '',
    status: 'Ativo',
    telefone1: '',
  });

  const handleInputChange = (event) => {
    event.persist();
    setformValues((inputs) => ({ ...inputs, [event.target.name]: event.target.value }));
  };

  const fetchContactById = async (id) => {
    if (!id) return;
    setLoading(true);
    try {
      const res = await api.get(`GruposFornecedoresContatos/ConsultarId?id=${id}`);
      setInputs({
        ...res.data.resposta,
        telefone1:
          res.data.resposta.telefone1 &&
          `(${res.data.resposta.ddd1}) ${res.data.resposta.telefone1}`,
      });
      setformValues({
        ...res.data.resposta,
        telefone1:
          res.data.resposta.telefone1 &&
          `(${res.data.resposta.ddd1}) ${res.data.resposta.telefone1}`,
      });
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const getInfoForForm = async () => {
    setLoading(true);
    try {
      const findCargos = await api.get('Cargos/Consultar?status=Ativo');
      setCargos(findCargos.data.resposta);
    } catch (err) {
      if (err?.response?.data?.resposta?.[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.');
      }
    }
    setLoading(false);
  };

  const updateContact = async (payload) => {
    const payloadUpadte = {
      ...inputs,
      ...payload,
      grupoFornecedorContatoId: Number(idGrupoContato),
      dataAtualizacao: inputs.dataAtualizacao,
    };
    try {
      const response = await api.put('GruposFornecedoresContatos', payloadUpadte);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Contato alterado com sucesso!');
        setInputs(response.data.resposta);
        // setformValues({});
      } else {
        setErros(handleErrorRequest(response));
      }
    } catch (error) {
      setErros(handleErrorRequest(error.response));
    }
  };

  const createContact = async (payload) => {
    try {
      const response = await api.post('GruposFornecedoresContatos', payload);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Contato criado com sucesso!');
        setformValues({
          cargo: '',
          cargoId: 0,
          ddd1: '',
          departamento: '',
          ehWhatsApp: "Indefinido",
          email: '',
          grupoFornecedorContatoId: 0,
          grupoFornecedorId: 0,
          nome: '',
          origemContato: '',
          ramal1: '',
          status: 'Ativo',
          telefone1: '',
        });
        setInputs({
          cargo: '',
          cargoId: 0,
          ddd1: '',
          departamento: '',
          ehWhatsApp: "Indefinido",
          email: '',
          grupoFornecedorContatoId: 0,
          grupoFornecedorId: 0,
          nome: '',
          origemContato: '',
          ramal1: '',
          status: 'Ativo',
          telefone1: '',
        });
      } else {
        setErros(handleErrorRequest(response));
      }
    } catch (error) {
      setErros(handleErrorRequest(error.response));
    }
  };

  const onSubmit = async () => {
    const payload = {
      ...formValues,
      ...(formValues.cargoId && { cargoId: Number(formValues.cargoId) }),
      ...(formValues.telefone1 && { ddd1: dddTel(formValues.telefone1, 'ddd') }),
      ...(formValues.telefone1 && { telefone1: dddTel(formValues.telefone1) }),
      ...{ grupoFornecedorId: Number(provider.grupoFornecedorId) },
      ancoraIdSolicitador: 0,
      loginIdAprovador: loginId,
      loginIdSolicitador: loginId,
    };

    if (!payload.telefone1) payload.ddd1 = '';

    isRegister ? createContact(payload) : updateContact(payload);
  };

  const fetchProvider = async () => {
    const res = await api.get(`Fornecedores/ConsultarId?id=${id}`);
    setProvider(res.data.resposta);
  };

  useEffect(() => {
    getInfoForForm();
    fetchProvider();
    if (window.location.pathname.includes('cadastrar')) {
      setLoading(false);
      setIsEditing(true);
      setIsRegister(true);
      return;
    }
    if (window.location.pathname.includes('editar')) {
      setIsEditing(true);
      fetchContactById(idGrupoContato);
      return;
    }
    fetchContactById(idGrupoContato);
    setIsEditing(false);
    setIsRegister(false);
  }, [idGrupoContato]);

  useEffect(() => {
    setSelectedGroup((input) => ({ ...input, tipoPessoa: inputs?.tipoPessoa }));
  }, [inputs?.tipoPessoa]);

  return (
    <div className={classes.root}>
      <Header />
      {isEditing ? (
        <Subheader
          title={`${isRegister ? 'Cadastrando' : 'Atualizando'} contato do fornecedor - ${
            provider?.nomeFantasia ?? ''
          }`}
          loading={isLoading}
          submit={onSubmit}
          back={false}
          submitText={`${isRegister ? 'Cadastrar' : 'Atualizar'}`}
        />
      ) : (
        <Subheader
          loading={isLoading}
          back={false}
          title={`Visualizando contato do fornecedor - ${provider?.nomeFantasia ?? ''}`}
        />
      )}
      <div className={classes.content}>
        <div className={classes.rootForm}>
          {isLoading ? (
            <Loading />
          ) : (
            <form onSubmit={onSubmit}>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Informações</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Nome</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          autoFocus
                          style={{ padding: 0 }}
                          className={classes.input}
                          placeholder="Nome"
                          value={formValues.nome}
                          name="nome"
                          disabled={!isEditing && !isRegister}
                          classes={{ input: classes.input }}
                          onBlur={(event) =>
                            getErros.includes('Nome') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Nome';
                              }),
                            )
                          }
                          error={getErros.includes('Nome')}
                          onChange={handleInputChange}
                          inputProps={{
                            minLength: 3,
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Status</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          disabled={!isEditing}
                          className={classes.input}
                          value={formValues.status || inputs?.status}
                          name="status"
                          onChange={handleInputChange}
                          error={getErros.includes('Status')}
                          onBlur={(event) =>
                            getErros.includes('Status') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Status';
                              }),
                            )
                          }
                        >
                          <option value="Ativo">Ativo</option>
                          <option value="Inativo">Inativo</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>E-mail</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="E-mail"
                          type="email"
                          value={formValues.email}
                          name="email"
                          disabled={!isEditing && !isRegister}
                          classes={{ input: classes.inputEmail }}
                          onBlur={(event) =>
                            getErros.includes('Email') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Email';
                              }),
                            )
                          }
                          error={getErros.includes('Email')}
                          onChange={handleInputChange}
                          inputProps={{
                            minLength: 3,
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Cargo</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={formValues.cargoId}
                          name="cargoId"
                          disabled={!isEditing && !isRegister}
                          onChange={(e) =>
                            setformValues((prv) => ({
                              ...prv,
                              cargoId: Number(e.target.value),
                            }))
                          }
                          error={getErros.includes('CargoId')}
                          onBlur={(event) =>
                            getErros.includes('CargoId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'CargoId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {cargos.map((cargo) => (
                            <option key={cargo.cargoId} value={cargo.cargoId}>
                              {cargo.cargo}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>

                    <Grid item xs={4}>
                      <label className={classes.label}>Telefone 1</label>
                      <Paper className={classes.medium} elevation={0}>
                        <PhoneMask
                          value={formValues.telefone1}
                          name="telefone1"
                          isDisabled={!isEditing && !isRegister}
                          autocomplete="off"
                          error={getErros.includes('Telefone1')}
                          onBlur={(event) =>
                            getErros.includes('Telefone1') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Telefone1';
                              }),
                            )
                          }
                          className={classes.input}
                          placeholder="Telefone 1"
                          onChange={handleInputChange}
                          inputProps={{
                            minLength: 2,
                            maxLength: 20,
                          }}
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={2}>
                      <label className={classes.label}>Ramal 1</label>
                      <Paper className={classes.medium} elevation={0} style={{ width: '91%' }}>
                        <Input
                          value={formValues.ramal1}
                          name="ramal1"
                          disabled={!isEditing && !isRegister}
                          error={getErros.includes('Ramal1')}
                          onBlur={(event) =>
                            getErros.includes('Ramal1') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Ramal1';
                              }),
                            )
                          }
                          inputProps={{
                            minLength: 2,
                            maxLength: 5,
                          }}
                          className={classes.input}
                          placeholder="Ramal 1"
                          onChange={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '');
                            handleInputChange(e);
                          }}
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Origem Contato</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          disabled={!isEditing && !isRegister}
                          placeholder="Origem Contato"
                          value={formValues.origemContato}
                          name="origemContato"
                          classes={{ input: classes.input }}
                          onBlur={(event) =>
                            getErros.includes('OrigemContato') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'OrigemContato';
                              }),
                            )
                          }
                          style={{ padding: 0 }}
                          error={getErros.includes('OrigemContato')}
                          onChange={handleInputChange}
                          inputProps={{
                            minLength: 3,
                            maxLength: 250,
                          }}
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Departamento</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          disabled={!isEditing && !isRegister}
                          classes={{ input: classes.inputText }}
                          placeholder="Departamento"
                          value={formValues.departamento}
                          name="departamento"
                          onBlur={(event) =>
                            getErros.includes('Departamento') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Departamento';
                              }),
                            )
                          }
                          error={getErros.includes('Departamento')}
                          onChange={handleInputChange}
                          inputProps={{
                            minLength: 3,
                            maxLength: 50,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>É WhatsApp</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={formValues.ehWhatsApp}
                          disabled={!isEditing && !isRegister}
                          name="ehWhatsApp"
                          onChange={handleInputChange}
                          error={getErros.includes('EhWhatsApp')}
                          onBlur={(event) =>
                            getErros.includes('EhWhatsApp') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EhWhatsApp';
                              }),
                            )
                          }
                        >
                          <option selected value="Indefinido">
                            Indefinido
                          </option>
                          <option selected value="Nao">
                            Não
                          </option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              {!isRegister && (
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className={classes.summary}
                  >
                    <Typography className={classes.heading}>Dados do Registro</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={6}>
                        <label className={classes.label}>Data de Registro</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            value={
                              inputs.dataRegistro && formatDateTimeToRender(inputs.dataRegistro)
                            }
                            readOnly
                            disabled={!isEditing}
                            placeholder="Data do Registro"
                          />
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Data da Atualização</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            value={
                              inputs.dataAtualizacao
                                ? formatDateTimeToRender(inputs.dataAtualizacao)
                                : ''
                            }
                            readOnly
                            disabled={!isEditing}
                            placeholder="Data da Atualização"
                          />
                        </Paper>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              )}
              {(isRegister || isEditing) && (
                <div className={classes.divButton}>
                  <button
                    variant="contained"
                    type="button"
                    onClick={onSubmit}
                    className={classes.button}
                  >
                    {isRegister ? 'Cadastrar' : 'Atualizar'}
                  </button>
                </div>
              )}
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
